function redirectFromQueryString() {
  const { pathname, search } = window.location;
  if (search === '?refresh=1') window.location.assign(pathname);
}

document.addEventListener('turbolinks:load', redirectFromQueryString);
